import client, { publicChatBotClient } from './axios';

let session = undefined;

// session storing into localstore to validation and login
const validatedSession = () => {
  const now = new Date().getTime();

  if (session.expiry < now) {
    session = undefined;
    localStorage.removeItem('session');
    return undefined;
  }

  return session;
};

export const getSession = () => {
  if (session) {
    return validatedSession();
  } else {
    const json = localStorage.getItem('session');

    if (!json) return undefined;
    session = JSON.parse(json);

    return validatedSession();
  }
};

export const setSession = (newSession) => {
  if (newSession) {
    session = newSession;
    localStorage.setItem('session', JSON.stringify(newSession));
  } else {
    localStorage.removeItem('session');
  }
};

// commoon method
export const get = async (uri) => {
  if (!getSession()) throw 'Not logged in';

  const response = await client.get(uri, {
    headers: {
      Authorization: `Bearer ${session.token}`,
    },
  });

  return response;
};

export const post = async (uri, payload) => {
  if (!getSession()) throw 'Not logged in';

  const response = await client.post(uri, payload, {
    headers: {
      Authorization: `Bearer ${session.token}`,
    },
  });

  return response;
};

export const put = async (uri, payload) => {
  if (!getSession()) throw 'Not logged in';

  const response = await client.put(uri, payload, {
    headers: {
      Authorization: `Bearer ${session.token}`,
    },
  });

  return response;
};

export const del = async (uri, payload) => {
  const session = getSession();

  if (!session) throw new Error('Not logged in');

  const response = await client.delete(uri, {
    headers: {
      Authorization: `Bearer ${session.token}`,
    },
    data: payload,
  });

  return response;
};

// public chatbot method
export const postPublicChatBot = async (uri, payload) => {
  const response = await publicChatBotClient.post(uri, payload, {});

  return response;
};
